import { render, staticRenderFns } from "./LayOut.vue?vue&type=template&id=31e34dac&"
import script from "./LayOut.vue?vue&type=script&lang=js&"
export * from "./LayOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports